import React from 'react'

class AssignedPairingSecurityList extends React.Component {
  render() {
    return (
      <div className="table-responsive">
        <table className="table table-sm table-stripped">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Tipo</th>
              <th scope="col">Número de serie</th>
              <th scope="col">PIN</th>
            </tr>
          </thead>
          <tbody>
            {this.props.SecurityLockers.map((securitylocker, index) => (
              <tr key={index}>
                <th scope="row">{securitylocker.Type}</th>
                <th scope="row">{securitylocker.SN}</th>
                <td scope="row">{securitylocker.Pin}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default AssignedPairingSecurityList
